import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import moment from "moment/moment";
import Big from "big.js";
import InstrumentIcon from "../../../components/instrument-icon";
import SvgIcon from "../../../components/svg-icon";
import associateServices from "../../../services";
import {toast} from "react-toastify";
import InformationToast from "../../../components/toast/InformationToast";
import {Link, useSearchParams} from "react-router-dom";
import stringHelper from "../../../helpers/string-helper";


const BonusesList = (props) => {
    const {data, getBonuses} = props
    const {t} = useTranslation()
    const [searchParams, setSearchParams] = useSearchParams()

    const [selectedBonus, setSelectedBonus] = useState('')

    const getBonusStatus = bonus => {

        if (bonus.is_completed)
            return t('transactions.bonuses.table.completed')


        if (!bonus.is_completed && !bonus.is_active)
            return t('transactions.bonuses.table.passive')


        if (!bonus.is_completed && bonus.is_active)
            return t('transactions.bonuses.table.active')

        return '';

    }
    const getBonusTheme = bonus => {

        if (bonus.is_completed)
            return 'xtable__text--green';


        if (!bonus.is_completed && !bonus.is_active)
            return 'xtable__text--red';


        if (!bonus.is_completed && bonus.is_active)
            return 'xtable__text--green';

        return '';
    }


    const handleDeactivateBonus = bonus => {
        console.log('bonus =- ', bonus)
        if (!selectedBonus)
            return setSelectedBonus(bonus.id)


        associateServices.cancelBonus({id: bonus.id}).then(res => {

            if (res?.status === 200)
                getBonuses()

            toast(<InformationToast
                icon={res?.status === 200 ? 'ti-check' : 'ti-x'}
                message={res?.status === 200 ? t(`api-notifications.${res?.data}`) : t(`api-notifications.${res?.errors}`)}
                title={res?.status === 200 ? t(`general.information`) : t(`general.error`)}
            />)
        })

    }

    return (
        <table className="xtable xtable--small">
            <thead>
            <tr>
                <th>#</th>
                <th>{t('transactions.bonuses.table.time')}</th>
                <th>{t('transactions.bonuses.table.currency')}</th>
                <th>{t('transactions.bonuses.table.status')}</th>
                <th className="text-right">{t('transactions.bonuses.table.amount')}</th>
                <th className="text-right">{t('transactions.bonuses.table.multiplier')}</th>
                <th className="text-right">{t('transactions.bonuses.table.wager')}</th>
                <th className="text-right">{t('transactions.bonuses.table.required-wager')}</th>
                <th className="text-right">{t('transactions.bonuses.table.actions')}</th>
            </tr>
            </thead>
            <tbody>

            {
                data?.map(debit => (
                    <tr key={debit?.id}>
                        <td className="cursor-pointer">
                            <Link
                                to={stringHelper.getModalPathBonus('bonus-detail', debit.id, searchParams)}
                                className="xtable__text xtable__text--text-secondary">
                                #{debit?.id}
                            </Link>
                        </td>

                        <td>
                            <div className="xtable__text">

                                                    <span className="xtable__text-date">
                                                                        {moment.unix(debit?.timestamp || 0).format('MMMM Do')}

                                                        <small>
                                                                        {moment.unix(debit?.timestamp || 0).format('h:mm:ss a')}
                                                                    </small>
                                                                    </span>

                            </div>
                        </td>

                        <td>
                            <div className="xtable__text">
                                <InstrumentIcon code={debit?.bonus.currency}/>
                                {debit?.bonus.currency}
                            </div>
                        </td>
                        <td className={getBonusTheme(debit)}>
                            {getBonusStatus(debit)}
                        </td>
                        <td className="text-right">
                            <div className="xtable__coin gap-1 text-secondary">

                                <span className="xtable__coin text-secondary" id={`bet-amount-${debit.id}`}>
                                    {Big(debit?.amount || 0).toFixed(8)}
                                </span>

                                <InstrumentIcon code={debit?.bonus?.currency}/>
                            </div>
                        </td>

                        <td className="text-right">
                            <div className="xtable__text">
                                x{Big(debit?.multiplier || 0).toFixed(2)}
                            </div>
                        </td>

                        <td className="text-right">
                            <div className="xtable__text">
                                {Big(debit?.current || 0).toFixed(2)}
                            </div>
                        </td>

                        <td className="text-right">
                            <div className="xtable__text">
                                {Big(debit?.required || 0).toFixed(2)}
                            </div>
                        </td>


                        <td className="text-right">
                            {
                                debit?.is_active && debit?.bonus?.cancel_able ?
                                    <div onClick={e => handleDeactivateBonus(debit)} className="cursor-pointer">
                                        <SvgIcon id={selectedBonus === debit?.id ? 'check' : 'cancel'}/>
                                    </div> : '#'
                            }
                        </td>
                    </tr>
                ))
            }

            </tbody>
        </table>
    )
}

export default BonusesList
